module.exports = __webpack_public_path__ + "img/icon.86a87468.svg";